import { AfterViewInit, ChangeDetectorRef, Component, HostListener, NgZone, OnDestroy, OnInit, ViewChild, Input } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators, ValidatorFn } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AreaService } from 'src/app/arealist.service';
import { CommonService, PropertyType, RequestForTypes, RequestType } from 'src/app/Shared/Common/common.service';
import { PropertyPostsService } from 'src/app/Shared/PostRequests/property-posts.service';
import { UsersService } from 'src/app/Shared/Users/users.service';
import { VenturesService } from 'src/app/Shared/Venture/ventures.service';
import { LoginModalComponent } from '../login-modal/login-modal.component';
import { finalize } from 'rxjs/operators';

declare var google: any;
declare var navigator: any;
declare var $: any;

@Component({
  selector: 'app-post-property',
  templateUrl: './post-property.component.html',
  styleUrls: ['./post-property.component.css']
})
export class PostPropertyComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() ViewType: string = 'Mobile';
  @Input() RequestId: string = '';
  isLoader: boolean = true;
  isPostEdit: boolean = false;
  userName: string;
  postRequest: any = new PropertyPostEntity;
  imageUpload: IImageUpload[] = [];
  imagePanoromaUpload: IImageUpload[] = [];
  propertyList: any[] = [];
  propertySubList: any[] = [];
  propertySubListById: any[] = [];
  areasList: any[] = [];
  imgIndex: number = 0;
  panoramaIndex: number = 0;
  authData: any;
  userProfileInfo: any;
  arrList: any[] = [];
  MeasureList: any[] = [];
  gpsLoaction: string = '';
  isTotalItemsList: any[] = [];
  isTotal: number = 0;

  croppedImage: string;
  postDetails: any;

  propertyPostForm: FormGroup;
  isOtherMobile: boolean = false;
  map: any;
  marker: any;
  geocoder: any;
  isOtherLocation: boolean = false;
  showMap: boolean = false;

  videoIndex = 0;
  isAgriculture: boolean = false;

  ventureList: any[] = [];
  showVenture: boolean = false;
  amenitiesList: any[] = [];
  buyAreaSearchTerm: string = '';
  showBuyAreaDropdown: boolean = false;
  rentAreaSearchTerm: string = '';
  showRentAreaDropdown: boolean = false;
  amenitySearchTerm: string = '';
  showAmenityDropdown: boolean = false;

  allAmenitiesList: any[] = [];
  private selectPickerTimerIds: any[] = [];

  // Loading states
  isAreasLoading: boolean = true;
  isAmenitiesLoading: boolean = true;
  private areasLoadAttempts: number = 0;
  private readonly MAX_LOAD_ATTEMPTS = 3;

  @ViewChild(LoginModalComponent) loginModal: LoginModalComponent;

  constructor(
    private postRouter: Router,
    private postCommonService: CommonService,
    private postUsersService: UsersService,
    private postPropertyPostsService: PropertyPostsService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    private fb: FormBuilder,
    private areaService: AreaService,
    private ventureService: VenturesService,
    private loginCommon: CommonService
  ) { }

  ngOnInit() {
    this.initializeComponent();
  }

  private initializeComponent(): void {
    this.loadUserData();
    this.initializeForm();
    this.loadInitialData();
    this.setupDefaultValues();
    this.loadCachedAreas();
    this.loadAmenitiesAsync();
  }

  private loadUserData(): void {
    this.authData = this.getFromLocalStorage('authData');
    this.userProfileInfo = this.getFromLocalStorage('authProfileData');
  }

  private getFromLocalStorage(key: string): any {
    const data = localStorage.getItem(key);
    return data && data !== 'undefined' ? JSON.parse(data) : null;
  }

  private initializeForm(): void {
    this.propertyPostForm = this.fb.group({
      otherMobileNo: ['', [this.mobileNumberValidator]],
      propertyMeasure: ['', [Validators.pattern('^\\d{1,6}(\\.\\d{0,2})?$'), Validators.required]],
      requestBudget: ['', [Validators.pattern('^[0-9]{1,12}$'), Validators.required]],
      bedRooms: ['', Validators.pattern('^[0-9]{1,2}$')],
      bathRooms: ['', Validators.pattern('^[0-9]{1,2}$')],
      noLift: ['', Validators.pattern('^[0-9]{1,2}$')],
      propertyAge: ['', [Validators.required, this.numericOnlyValidator()]],
      roadSize: ['', Validators.pattern('^[0-9]{1,4}$')]
    });
  }

  private loadInitialData(): void {
    this.LoadMeasures();
    this.LoadAllPropertyType();
    this.LoadAllPropertySubType();
    this.LoadVentureList();
    this.loadMapBasedOnAddress();

    if (this.RequestId && this.RequestId !== '') {
      this.postRequest.RequestId = this.RequestId;
      this.isPostEdit = true;
      this.loadPropertyDetails();
    }
  }

  private setupDefaultValues(): void {
    this.postRequest.requestType = RequestType.Buy;
    this.postRequest.propertyType = PropertyType.Residential;
    this.postRequest.requestForType = RequestForTypes.Self;
    this.postRequest.requestBudget = '';
    this.doChangeRequestType(3);
    this.postRequest.selectedAreasID = [];

    if (!this.postDetails) this.postDetails = {} as any;
    this.postDetails.PropertyTypeName = 'Residential';
  }

  private loadCachedAreas(): void {
    const cacheKey = 'cachedAreasList';
    const cacheExpiry = 'cachedAreasListExpiry';
    const now = Date.now();

    const cachedData = localStorage.getItem(cacheKey);
    const cachedExpiry = localStorage.getItem(cacheExpiry);

    if (cachedData && cachedExpiry && parseInt(cachedExpiry) > now) {
      this.areasList = JSON.parse(cachedData);
      this.isAreasLoading = false;
      this.cdr.detectChanges();
      return;
    }

    this.loadAreasWithRetry();
  }

  // Update the loadAreasWithRetry method:
  private loadAreasWithRetry(): void {
    this.isAreasLoading = true;
    this.cdr.detectChanges();

    const loadAreas = () => {
      const areas = this.areaService.getAreas();
      if (areas && areas.length > 0) {
        this.areasList = areas;
        this.cacheAreas(areas);
        this.isAreasLoading = false;
        this.cdr.detectChanges();
      } else if (this.areasLoadAttempts < this.MAX_LOAD_ATTEMPTS) {
        this.areasLoadAttempts++;
        // Show retry message
        this.cdr.detectChanges();
        setTimeout(loadAreas, 500 * this.areasLoadAttempts);
      } else {
        this.isAreasLoading = false;
        this.cdr.detectChanges();
      }
    };

    // Small delay to ensure loading indicator shows
    setTimeout(loadAreas, 100);
  }

  private cacheAreas(areas: any[]): void {
    const cacheKey = 'cachedAreasList';
    const cacheExpiry = 'cachedAreasListExpiry';
    const expiryTime = Date.now() + (30 * 60 * 1000); // 30 minutes

    localStorage.setItem(cacheKey, JSON.stringify(areas));
    localStorage.setItem(cacheExpiry, expiryTime.toString());
  }

  private loadAmenitiesAsync(): void {
    this.ventureService.GetAllAmenitiesList().subscribe({
      next: (res) => {
        if (res.status === 1) {
          this.allAmenitiesList = res.body;
          this.filterAmenities();
        }
      },
      error: (err) => {
        this.isAmenitiesLoading = false;
        this.cdr.detectChanges();
      }
    });
  }

  onPropertyTypeChange(propertyTypeName: string) {
    if (!this.postDetails) this.postDetails = {} as any;
    this.postDetails.PropertyTypeName = propertyTypeName;
    this.filterAmenities();

    if (propertyTypeName.toLowerCase() === 'land')
      this.LoadSubPropertyByID(PropertyType.Land);
    else if (propertyTypeName.toLowerCase() === 'commercial')
      this.LoadSubPropertyByID(PropertyType.Commercial);
    else
      this.LoadSubPropertyByID(PropertyType.Residential);
  }

  filterAmenities() {
    this.isAmenitiesLoading = true;
    const propertyType = this.postDetails?.PropertyTypeName?.toLowerCase() || 'residential';

    // Use setTimeout to prevent UI blocking
    setTimeout(() => {
      this.amenitiesList = this.allAmenitiesList.filter((amenity: any) => {
        const group = amenity.AminityGroup?.toLowerCase();
        return group === propertyType || group === 'General';
      });
      this.isAmenitiesLoading = false;
      this.cdr.detectChanges();
    }, 50);
  }

  numericOnlyValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === undefined || value === '') {
        return { notNumeric: true };
      }
      const numValue = Number(value);
      if (isNaN(numValue)) return { notNumeric: true };
      if (numValue === -1 || (numValue >= 0 && numValue <= 999)) return null;
      return { outOfRange: true };
    };
  }

  CheckAuthentication(): boolean {
    this.authData = this.getFromLocalStorage('authData');
    this.userProfileInfo = this.getFromLocalStorage('authProfileData');
    return this.authData && this.authData.UserID;
  }

  private LoadVentureList() {
    this.ventureList = [];
    this.ventureService.GetVentureDetails(0, 0, 1).subscribe((res) => {
      if (res.status == 1) this.ventureList = res.body;
    });
  }

  LoadMeasures() {
    this.MeasureList = [];
    this.postPropertyPostsService.GetAllUnitsList(0).subscribe((res) => {
      if (res.status == 1) this.MeasureList = res.body;
    });
  }

  LoadAllPropertyType() {
    this.postPropertyPostsService.GetAllPropertyType().subscribe(res => {
      if (res.status == 1) this.propertyList = res.body;
      this.isLoader = false;
    }, () => this.isLoader = false);
  }

  LoadAllPropertySubType() {
    this.postPropertyPostsService.GetAllPropertySubType().subscribe(res => {
      if (res.status == 1) {
        this.propertySubList = res.body;
        this.postRequest.propertyType = PropertyType.Residential;
        this.LoadSubPropertyByID(PropertyType.Residential);
      }
      this.isLoader = false;
    }, () => this.isLoader = false);
  }

  LoadSubPropertyByID(subType: number) {
    this.postRequest.propertyType = subType;
    this.propertySubListById = this.propertySubList.filter((sub) => sub.PropertyTypeID == subType);

    const validators = this.getValidatorsForSubType(subType);
    this.updateFormValidators(validators);
  }

  private getValidatorsForSubType(subType: number): any {
    if (subType == 1) {
      return {
        bedRooms: [Validators.pattern('^[0-9]{1,2}$'), Validators.required],
        bathRooms: [Validators.pattern('^[0-9]{1,2}$'), Validators.required],
        noLift: [Validators.pattern('^[0-9]{1,2}$'), Validators.required],
        propertyAge: [Validators.pattern('^(-1|[0-9]{1,3})$'), Validators.required]
      };
    } else if (subType == 2) {
      return {
        bedRooms: [Validators.pattern('^[0-9]{1,2}$')],
        bathRooms: [Validators.pattern('^[0-9]{1,2}$')],
        noLift: [Validators.pattern('^[0-9]{1,2}$'), Validators.required],
        propertyAge: [Validators.pattern('^(-1|[0-9]{1,3})$'), Validators.required]
      };
    } else {
      return {
        bedRooms: [Validators.pattern('^[0-9]{1,2}$')],
        bathRooms: [Validators.pattern('^[0-9]{1,2}$')],
        noLift: [Validators.pattern('^[0-9]{1,2}$')],
        propertyAge: [Validators.pattern('^(-1|[0-9]{1,3})$')],
        roadSize: [Validators.pattern('^[0-9]{1,4}$')]
      };
    }
  }

  private updateFormValidators(validators: any): void {
    Object.keys(validators).forEach(field => {
      const control = this.propertyPostForm.get(field);
      if (control) {
        control.setValidators(validators[field]);
        control.updateValueAndValidity();
      }
    });
  }

  doLoadIsTotalItems() {
    let mesr = this.MeasureList.find(x => x.UnitID == this.postRequest.unitID);
    if (mesr != null) {
      this.isTotalItemsList = [
        { unitValue: 1, unitText: "Total Price" },
        { unitValue: 0, unitText: "Per " + mesr.UnitName }
      ];
    }
  }

  loadPropertyDetails() {
    this.isLoader = true;
    this.postPropertyPostsService.GetUserPostDetailsByPropertyID(this.postRequest.RequestId).subscribe({
      next: (res) => {
        if (res.status === 1 && res.body && res.body.length > 0) {
          this.processPropertyDetails(res.body[0]);
        }
        this.isLoader = false;
      },
      error: () => {
        this.postDetails = null;
        this.isLoader = false;
      }
    });
  }

  private processPropertyDetails(property: any): void {
    this.postDetails = property;
    this.mapPropertyToPostRequest(property);
    this.loadImages(property);
    this.loadMapBasedOnAddress();
    this.doLoadIsTotalItems();
    this.parseSelectedData(property);
    this.setRequestType(property.Req_Type_ID);
  }

  private mapPropertyToPostRequest(property: any): void {
    this.postRequest.selectedSubProdID = property.PropertySubTypeID;
    this.postRequest.Category = property.Category;
    this.postRequest.unitID = property.UnitID;
    this.postRequest.propertyMeasure = property.Measurement;
    this.isTotal = property.isTotal ? 1 : 0;
    this.postRequest.requestBudget = parseInt(property.Budget);
    this.postRequest.bedRooms = property.Bed_Rooms;
    this.postRequest.bathRooms = property.Bath_Rooms;
    this.postRequest.noLift = property.Lift;
    this.postRequest.isParking = property.Car_Parking?.toString() || "0";
    this.postRequest.propertyAge = property.Property_Age;
    this.postRequest.propertyFacing = property.Property_Facing;
    this.postRequest.layoutAuthority = property.Layout_Authority;
    this.postRequest.roadType = property.Road_Type;
    this.postRequest.roadSize = property.Road_Size;
    this.postRequest.socilType = property.Socil_Type;
    this.postRequest.isFencing = property.Fencing?.toString() || "0";
    this.postRequest.isElectricity = property.Electricity?.toString() || "0";
    this.postRequest.isWaterFacility = property.Water_Facility?.toString() || "0";
    this.postRequest.distanceNHW = property.Distance_NHW;
    this.postRequest.distanceORR = property.Distance_ORR;
    this.postRequest.cropPlantation = property.Crop_Plantation;
    this.postRequest.shortDescription = property.ShortDescription;
    this.postRequest.address = property.Address;
    this.postRequest.lattitude = property.Latitude;
    this.postRequest.logitude = property.Longitude;
    this.postRequest.propertyType = parseInt(property.PropertyTypeID);
    this.postRequest.reqStatus = parseInt(property.ReqStatus);
    this.postRequest.isVenture = property.IsVenture;
    this.postRequest.ventureId = property.VentureId;

    this.propertyPostForm.patchValue({
      otherMobileNo: this.postRequest.otherMobileNo,
      propertyMeasure: this.postRequest.propertyMeasure,
      requestBudget: this.postRequest.requestBudget,
      bedRooms: this.postRequest.bedRooms,
      bathRooms: this.postRequest.bathRooms,
      noLift: this.postRequest.noLift,
      propertyAge: this.postRequest.propertyAge,
      roadSize: this.postRequest.roadSize
    });
  }

  // Replace the existing loadImages method with this:

  private loadImages(property: any): void {
    this.imageUpload = [];
    this.imagePanoromaUpload = [];

    // Load regular images (1-15)
    for (let i = 1; i <= 15; i++) {
      this.addImageToUpload(property[`Image${i}`]);
    }

    // Load panorama images - Fix: Ensure they are added correctly
    for (let i = 1; i <= 3; i++) {
      const panoramaPath = property[`P_Image${i}`];
      if (panoramaPath && panoramaPath !== "") {
        this.imagePanoromaUpload.push({ imgPath: panoramaPath, isVideo: false });
        this.panoramaIndex++;
      }
    }

    // Load videos
    for (let i = 1; i <= 3; i++) {
      this.addImageToUpload(property[`Video${i}`]);
    }

    // Update image indices based on loaded images
    this.imgIndex = this.imageUpload.filter(img => !img.isVideo).length;
    this.videoIndex = this.imageUpload.filter(img => img.isVideo).length;

    this.cdr.detectChanges();
  }

  private parseSelectedData(property: any): void {
    this.postRequest.selectedAreasID = [];
    this.postRequest.Amenities = [];

    let areasString = property.AREAS_JSON || '';
    let amenitiesString = property.Amenities || '';

    if (areasString) {
      this.postRequest.selectedAreasID = areasString.includes(',')
        ? areasString.split(',').map(area => area.trim())
        : [areasString.trim()];
    }

    if (amenitiesString) {
      const cleanAmenities = amenitiesString.replace(/,$/, '');
      this.postRequest.Amenities = cleanAmenities.split(',').map(Number);
    }
  }

  private setRequestType(reqTypeId: string): void {
    if (reqTypeId === 'R') this.postRequest.requestType = RequestType.Rent;
    else if (reqTypeId === 'S') this.postRequest.requestType = RequestType.Sale;
    else this.postRequest.requestType = RequestType.Buy;
  }

  // Update addImageToUpload method:
  addImageToUpload(imagePath: string, isPanorama: boolean = false) {
    if (imagePath && imagePath !== "") {
      if (isPanorama) {
        this.imagePanoromaUpload.push({ imgPath: imagePath, isVideo: false });
      } else {
        const isVideo = imagePath.toLowerCase().endsWith('.mp4');
        this.imageUpload.push({ imgPath: imagePath, isVideo });
      }
    }
  }

  doChangeRequestForType(forType: number) {
    if (forType == 1) {
      this.postRequest.requestForType = RequestForTypes.Self;
      this.isOtherMobile = false;
      this.propertyPostForm.patchValue({ otherMobileNo: '' });
      this.propertyPostForm.get('otherMobileNo')?.clearValidators();
      this.propertyPostForm.get('otherMobileNo')?.updateValueAndValidity();
    } else if (forType == 2) {
      this.onOtherRadioButtonSelection(true);
      this.postRequest.requestForType = RequestForTypes.Others;
      this.isOtherMobile = true;
      this.propertyPostForm.get('otherMobileNo')?.setValidators([Validators.required]);
      this.propertyPostForm.get('otherMobileNo')?.updateValueAndValidity();
    } else {
      this.postRequest.requestForType = RequestForTypes.Self;
      this.isOtherMobile = false;
      this.propertyPostForm.patchValue({ otherMobileNo: '' });
      this.propertyPostForm.get('otherMobileNo')?.clearValidators();
      this.propertyPostForm.get('otherMobileNo')?.updateValueAndValidity();
    }
  }

  doChangeVenture(type: number) {
    this.showVenture = type == 1;
    this.postRequest.isVenture = type == 1;
    if (type == 1) this.LoadVentureList();
  }

  onOtherRadioButtonSelection(isOtherSelected: boolean) {
    const otherMobileNoControl = this.propertyPostForm.get('otherMobileNo');
    if (isOtherSelected) {
      otherMobileNoControl?.setValidators([Validators.required, this.mobileNumberValidator]);
    } else {
      otherMobileNoControl?.setValidators([this.mobileNumberValidator]);
    }
    otherMobileNoControl?.updateValueAndValidity();
  }

  doSelectSubProperty(sub: any) {
    this.postRequest.isPlot = false;
    this.postRequest.isLand = false;

    if ([12, 13, 14].includes(sub.PropertySubTypeID)) {
      this.postRequest.isPlot = true;
      this.isAgriculture = false;
    } else if ([15, 16].includes(sub.PropertySubTypeID)) {
      this.postRequest.isLand = true;
      this.isAgriculture = true;
    } else {
      this.postRequest.isPlot = false;
      this.postRequest.isLand = false;
      this.isAgriculture = false;
    }

    this.postRequest.selectedSubProdID = sub.PropertySubTypeID;
    this.LoadSubPropertyByID(this.postRequest.propertyType);

    const excludedSubProdIDs = [17, 20, 21, 22, 23];
    if (excludedSubProdIDs.includes(this.postRequest.selectedSubProdID)) {
      const controls = ['bedRooms', 'bathRooms', 'noLift', 'propertyAge'];
      controls.forEach(control => {
        this.propertyPostForm.get(control)?.clearValidators();
        this.propertyPostForm.get(control)?.setValidators([Validators.pattern('^[0-9]{1,2}$')]);
        this.propertyPostForm.get(control)?.updateValueAndValidity();
      });
    }
  }

  doChangePostValue(type: string, val: string) {
    switch (type) {
      case 'Parking': this.postRequest.isParking = val; break;
      case 'Fencing': this.postRequest.isFencing = val; break;
      case 'Electricity': this.postRequest.isElectricity = val; break;
      case 'WaterFacility': this.postRequest.isWaterFacility = val; break;
    }
  }

  removeUploadedImg(rmIndex: number, type: string): void {
    const fullPath = type === 'I'
      ? this.imageUpload[rmIndex]?.imgPath
      : this.imagePanoromaUpload[rmIndex]?.imgPath;

    if (fullPath) {
      const fileName = fullPath.split('/').pop();
      if (fileName) {
        this.postUsersService.deleteFile(fileName).subscribe({
          next: () => {
            if (type === 'I') {
              this.imageUpload.splice(rmIndex, 1);
              // Update indices based on remaining images
              this.imgIndex = this.imageUpload.filter(img => !img.isVideo).length;
              this.videoIndex = this.imageUpload.filter(img => img.isVideo).length;
            } else {
              this.imagePanoromaUpload.splice(rmIndex, 1);
              this.panoramaIndex = this.imagePanoromaUpload.length;
            }
            this.cdr.detectChanges();
          },
          error: (error) => console.error(`Failed to delete file '${fileName}':`, error)
        });
      }
    }
  }

  doPostRequestSubmit() {
    if (!this.CheckAuthentication()) {
      this.openLoginModal();
      return;
    }

    this.propertyPostForm.markAllAsTouched();

    if (!this.propertyPostForm.valid) {
      this.postCommonService.CallToster('E', 'Invalid data. Please check Red Marked columns.');
      return;
    }

    this.mapFormValuesToPostRequest();

    if (!this.validatePostRequest()) return;

    const hasImage = this.imageUpload.some(file => !file.isVideo);
    // if (!hasImage) {
    //   this.postCommonService.CallToster('E', 'Please upload at least one Property Image.');
    //   return;
    // }
    if (this.postRequest.requestType !== RequestType.Buy && !hasImage) {
      this.postCommonService.CallToster('E', 'Please upload at least one Property Image.');
      return;
    }

    if (this.isPostEdit) {
      this.doUpdatePostDetails();
    } else {
      this.SaveUserRequestData();
    }
  }

  private validatePostRequest(): boolean {
    const reg = /^\d+$/;
    const _mobExp = /^([6-9]{1})([0123456789]{1})([0-9]{8})$/;
    const _decimal = /^\d{0,6}(\.\d{0,2})?$/;

    if (this.userProfileInfo?.UserName?.toLowerCase() == 'guest') {
      this.postCommonService.CallToster('E', 'Please update your Name from guest.');
      return false;
    }

    // Find the image upload validation section and update:
    if (this.postRequest.requestType > 1) {
      if (this.postRequest.Amenities.length == 0) {
        this.postCommonService.CallToster('E', 'Minimum one Amenities should be selected...!');
        return false;
      }
      if (this.postRequest.address == '') {
        this.postCommonService.CallToster('E', 'Please enter Location / Address...!');
        return false;
      }
      // Only require images for Rent and Sale, not for Buy
      if (this.postRequest.requestType !== RequestType.Buy && this.imageUpload.length == 0) {
        this.postCommonService.CallToster('E', 'Please upload atleast one property Image...!');
        return false;
      }
    }
    // Add more validation logic here (keeping existing validations)

    return true;
  }

  SaveUserRequestData() {
    try {
      if (!this.validateInputs()) {
        this.postCommonService.CallToster('E', 'Property data should not be 0.');
        return;
      }

      let Preferred_Areas = '';
      // Fix: For Buy (requestType == 1) - multi-select, save as comma-separated
      // For Rent/Sale (requestType > 1) - single select, save as single value
      if (this.postRequest.requestType == 1) {
        // Buy mode - multiple areas
        if (Array.isArray(this.postRequest.selectedAreasID) && this.postRequest.selectedAreasID.length > 0) {
          Preferred_Areas = this.postRequest.selectedAreasID.map(id => id).join(',') + ',';
        } else {
          Preferred_Areas = '';
        }
      } else {
        // Rent/Sale mode - single area
        if (this.postRequest.selectedAreasID && this.postRequest.selectedAreasID !== '') {
          Preferred_Areas = this.postRequest.selectedAreasID + ',';
        } else {
          Preferred_Areas = '';
        }
      }

      const SelectedAmenities = this.postRequest.Amenities.length > 0
        ? this.postRequest.Amenities.join(',') + ','
        : '';

      this.isLoader = true;
      const imgList = this.imageUpload.filter(el => !el.isVideo);
      const videosList = this.imageUpload.filter(el => el.isVideo);

      const userPostRequest = this.buildUserPostRequest(Preferred_Areas, SelectedAmenities, imgList, videosList);

      this.postPropertyPostsService.SaveUpdateUserPost(userPostRequest).subscribe({
        next: (res) => this.handleSaveResponse(res),
        error: () => this.handleSaveError()
      });
    } catch (error) {
      this.isLoader = false;
      this.postCommonService.CallToster('E', 'Something went wrong. Please try again later.');
    }
  }

  private buildUserPostRequest(Preferred_Areas: string, SelectedAmenities: string, imgList: any[], videosList: any[]): any {
    return {
      RequestID: 0, UserID: this.authData.UserID, Date_of_Posting: new Date(),
      Req_Type: this.postRequest.requestType === RequestType.Sale ? 'S' : this.postRequest.requestType === RequestType.Rent ? 'R' : 'B',
      PropertyTypeID: this.postRequest.propertyType, PropertySubTypeID: this.postRequest.selectedSubProdID,
      Proprty_For: this.postRequest.requestForType, Other_Contact: this.postRequest.otherMobileNo,
      Preferred_Areas: Preferred_Areas, Budget: parseInt(this.postRequest.requestBudget),
      Property_Measure: this.postRequest.propertyMeasure, UnitID: parseInt(this.postRequest.unitID),
      Property_Facing: this.postRequest.propertyFacing, Layout_Authority: this.postRequest.layoutAuthority,
      Road_Type: this.postRequest.roadType, Socil_Type: this.postRequest.socilType,
      Road_Size: this.postRequest.roadSize, Fencing: parseInt(this.postRequest.isFencing),
      Electricity: parseInt(this.postRequest.isElectricity), Water_Facility: parseInt(this.postRequest.isWaterFacility),
      Distance_NHW: this.postRequest.distanceNHW, Distance_ORR: this.postRequest.distanceORR,
      Crop_Plantation: this.postRequest.cropPlantation, ShortDescription: this.postRequest.shortDescription,
      Latitude: this.postRequest.lattitude, Longitude: this.postRequest.logitude,
      Address: this.postRequest.address,
      Image1: imgList[0]?.imgPath || '', Image2: imgList[1]?.imgPath || '', Image3: imgList[2]?.imgPath || '',
      Image4: imgList[3]?.imgPath || '', Image5: imgList[4]?.imgPath || '', Image6: imgList[5]?.imgPath || '',
      Image7: imgList[6]?.imgPath || '', Image8: imgList[7]?.imgPath || '', Image9: imgList[8]?.imgPath || '',
      Image10: imgList[9]?.imgPath || '', Image11: imgList[10]?.imgPath || '', Image12: imgList[11]?.imgPath || '',
      Image13: imgList[12]?.imgPath || '', Image14: imgList[13]?.imgPath || '', Image15: imgList[14]?.imgPath || '',
      P_Image1: this.imagePanoromaUpload[0]?.imgPath || '', P_Image2: this.imagePanoromaUpload[1]?.imgPath || '', P_Image3: this.imagePanoromaUpload[2]?.imgPath || '',
      Video1: videosList[0]?.imgPath || '', Video2: videosList[1]?.imgPath || '', Video3: videosList[2]?.imgPath || '',
      Status: 0, IsPlot: this.postRequest.isPlot, IsLand: this.postRequest.isLand,
      Bed_Rooms: this.postRequest.bedRooms ? parseInt(this.postRequest.bedRooms) : null,
      Bath_Rooms: this.postRequest.bathRooms ? parseInt(this.postRequest.bathRooms) : null,
      Car_Parking: this.postRequest.isParking == '1' ? 1 : 0,
      Lift: this.postRequest.noLift ? parseInt(this.postRequest.noLift) : null,
      Property_Age: this.postRequest.propertyAge, Amenities: SelectedAmenities,
      isTotalPrice: this.isTotal == 1 ? 1 : 0,
      isVenture: this.postRequest.isVenture,
      ventureId: this.postRequest.ventureId
    };
  }

  private handleSaveResponse(res: any): void {
    this.isLoader = false;
    if (res.status === 1 && !res.isError && res.body) {
      this.SendConfirmationSMS(res.body);
      if (this.postRequest.otherMobileNo) this.SendOtherConfirmationSMS(res.body);

      this.clearCachedData();
      this.postCommonService.CallToster('S', 'Your post has been submitted successfully!');

      const redirectUrl = this.ViewType === 'Mobile' ? '/m/viewposts' : '/viewposts';
      this.postRouter.navigateByUrl(redirectUrl);
    } else if (res.status === 0 && res.statusCode === 409) {
      this.postCommonService.CallToster('E', `${res.errorMessage}: ${res.body}`);
    } else {
      this.postCommonService.CallToster('E', 'Unable to save your post details. Please try again later.');
    }
  }

  private handleSaveError(): void {
    this.isLoader = false;
    this.postCommonService.CallToster('E', 'Unable to save your post details. Please try again later.');
  }

  private clearCachedData(): void {
    Object.keys(localStorage)
      .filter(key => key.startsWith("UserPostData_") || key.startsWith("CacheExpiration_"))
      .forEach(key => localStorage.removeItem(key));
  }

  buildWhatsAppMessage(post: any, isUpdate: boolean = false): string {
    const header = isUpdate ? "🔄 Property Post Updated" : "🆕 New Property Post Submitted";
    let msg = `${header}\n\n`;
    if (post.PropertyCode) msg += `🏷️ Property Code: ${post.PropertyCode}\n`;
    msg += `👤 Posted By: ${this.userProfileInfo?.UserName || "N/A"}\n`;
    msg += `📞 Contact: ${this.userProfileInfo?.MobileNo || this.userProfileInfo?.Phone || "N/A"}\n\n`;
    msg += `🏡 Property Type: ${this.getPropertyTypeName(post.PropertyTypeID)}\n`;
    msg += `📋 Sub Type: ${this.getSubPropertyTypeName(post.PropertySubTypeID)}\n`;
    msg += `📍 Address: ${post.Address || "N/A"}\n`;
    msg += `📐 Size: ${post.Property_Measure} ${this.getUnitName(post.UnitID)}\n`;
    msg += `💰 Budget: ₹${post.Budget}\n`;
    if (post.Bed_Rooms) msg += `🛏️ Bedrooms: ${post.Bed_Rooms}\n`;
    if (post.Bath_Rooms) msg += `🛁 Bathrooms: ${post.Bath_Rooms}\n`;
    msg += `🚗 Parking: ${post.Car_Parking == 1 ? "Yes" : "No"}`;
    if (post.Lift) msg += ` | Lift: ${post.Lift}\n`;
    else msg += `\n`;
    msg += `\n📑 Description: ${post.ShortDescription || "N/A"}\n\n`;
    if (post.Amenities && post.Amenities !== "") {
      const amenityNames = this.getAmenityNames(post.Amenities);
      msg += `✨ Amenities: ${amenityNames.join(', ')}\n\n`;
    }
    if (post.Image1) msg += `🖼️ Image1: ${post.Image1}\n`;
    if (post.Image2) msg += `🖼️ Image2: ${post.Image2}\n`;
    msg += `\n✅ Submitted on: ${new Date().toLocaleString()}`;
    return msg;
  }

  getPropertyTypeName(propertyTypeID: number): string {
    const propertyType = this.propertyList.find(item => item.PropertyTypeID === propertyTypeID);
    return propertyType ? propertyType.PropertyTypeName : `Unknown (ID: ${propertyTypeID})`;
  }

  getSubPropertyTypeName(subPropertyTypeID: number): string {
    const subPropertyType = this.propertySubList.find(item => item.PropertySubTypeID === subPropertyTypeID);
    return subPropertyType ? subPropertyType.PropertySubTypeName : `Unknown (ID: ${subPropertyTypeID})`;
  }

  getUnitName(unitID: number): string {
    const unit = this.MeasureList.find(item => item.UnitID === unitID);
    return unit ? unit.UnitName : `Unknown (ID: ${unitID})`;
  }

  getAmenityNames(amenitiesString: string): string[] {
    if (!amenitiesString) return [];
    const amenityIDs = amenitiesString.replace(/,$/, '').split(',').map(id => parseInt(id.trim()));
    return amenityIDs.map(id => {
      const amenity = this.amenitiesList.find(item => item.AmenityID === id);
      return amenity ? amenity.AmenityName : `Unknown (ID: ${id})`;
    });
  }

  SendAdminNotification(actionType: string, userName: string, mobile: string, propertyType?: string) {
    this.loginCommon.sendAdminNotification(actionType, userName, mobile, propertyType).subscribe();
  }

  SendWhatsAppToUser(whatsappMsg: string) {
    const userMobile = this.userProfileInfo?.MobileNo || this.authData?.MobileNo || this.userProfileInfo?.Phone;
    if (userMobile) {
      this.loginCommon.postMsgWithUrlToWhatsapp(userMobile, whatsappMsg).subscribe();
    }
  }

  doUpdatePostDetails() {
    this.isLoader = true;
    const imgList = this.imageUpload.filter(el => !el.isVideo);
    const videosList = this.imageUpload.filter(el => el.isVideo);
    const SelectedAmenities = this.postRequest.Amenities.length > 0 ? this.postRequest.Amenities.join(',') + ',' : '';

    // Fix: Build Preferred_Areas correctly for Edit mode
    let Preferred_Areas = '';
    if (this.postRequest.requestType == 1) {
      // Buy mode - multiple areas
      if (Array.isArray(this.postRequest.selectedAreasID) && this.postRequest.selectedAreasID.length > 0) {
        Preferred_Areas = this.postRequest.selectedAreasID.map(id => id).join(',') + ',';
      } else {
        Preferred_Areas = '';
      }
    } else {
      // Rent/Sale mode - single area
      if (this.postRequest.selectedAreasID && this.postRequest.selectedAreasID !== '') {
        Preferred_Areas = this.postRequest.selectedAreasID + ',';
      } else {
        Preferred_Areas = '';
      }
    }

    console.log(Preferred_Areas);

    const userPostRequest = {
      RequestID: this.postRequest.RequestId,
      Other_Contact: this.postRequest.otherMobileNo,
      Budget: parseInt(this.postRequest.requestBudget),
      Property_Measure: this.postRequest.propertyMeasure,
      UnitID: parseInt(this.postRequest.unitID),
      isTotalPrice: this.isTotal == 1 ? 1 : 0,
      ShortDescription: this.postRequest.shortDescription,
      Latitude: this.postRequest.lattitude,
      Longitude: this.postRequest.logitude,
      Address: this.postRequest.address,
      Preferred_Areas: Preferred_Areas,
      Image1: imgList[0]?.imgPath || '',
      Image2: imgList[1]?.imgPath || '',
      Image3: imgList[2]?.imgPath || '',
      Image4: imgList[3]?.imgPath || '',
      Image5: imgList[4]?.imgPath || '',
      Image6: imgList[5]?.imgPath || '',
      Image7: imgList[6]?.imgPath || '',
      Image8: imgList[7]?.imgPath || '',
      Image9: imgList[8]?.imgPath || '',
      Image10: imgList[9]?.imgPath || '',
      Image11: imgList[10]?.imgPath || '',
      Image12: imgList[11]?.imgPath || '',
      Image13: imgList[12]?.imgPath || '',
      Image14: imgList[13]?.imgPath || '',
      Image15: imgList[14]?.imgPath || '',
      P_Image1: this.imagePanoromaUpload[0]?.imgPath || '',
      P_Image2: this.imagePanoromaUpload[1]?.imgPath || '',
      P_Image3: this.imagePanoromaUpload[2]?.imgPath || '',
      Video1: videosList[0]?.imgPath || '',
      Video2: videosList[1]?.imgPath || '',
      Video3: videosList[2]?.imgPath || '',
      Status: this.postRequest.reqStatus,
      Bed_Rooms: this.postRequest.bedRooms ? parseInt(this.postRequest.bedRooms) : null,
      Bath_Rooms: this.postRequest.bathRooms ? parseInt(this.postRequest.bathRooms) : null,
      Car_Parking: this.postRequest.isParking == '1' ? 1 : 0,
      Lift: this.postRequest.noLift ? parseInt(this.postRequest.noLift) : null,
      Property_Age: this.postRequest.propertyAge,
      Road_Type: this.postRequest.roadType,
      Socil_Type: this.postRequest.socilType,
      Property_Facing: this.postRequest.propertyFacing,
      Layout_Authority: this.postRequest.layoutAuthority,
      Electricity: parseFloat(this.postRequest.isElectricity),
      Water_Facility: parseInt(this.postRequest.isWaterFacility),
      Road_Size: this.postRequest.roadSize,
      Crop_Plantation: this.postRequest.cropPlantation,
      Distance_NHW: this.postRequest.distanceNHW,
      Distance_ORR: this.postRequest.distanceORR,
      Fencing: parseInt(this.postRequest.isFencing),
      Amenities: SelectedAmenities
    };

    this.postPropertyPostsService.UpdatePostDetails(userPostRequest).subscribe({
      next: (res) => {
        this.isLoader = false;
        if (res.status === 1 && !res.isError) {
          this.clearCachedData();
          this.postCommonService.CallToster('S', 'Successfully submitted your post!');
          setTimeout(() => {
            const redirectUrl = this.ViewType === 'Mobile' ? '/m/viewposts' : '/viewposts';
            this.postRouter.navigateByUrl(redirectUrl);
          }, 500);
        } else {
          this.postCommonService.CallToster('E', 'Unable to save your post details. Please try again later.');
        }
      },
      error: () => {
        this.isLoader = false;
        this.postCommonService.CallToster('E', 'Unable to save your post details. Please try again later.');
      }
    });
  }

  openLoginModal() {
    setTimeout(() => {
      if (this.loginModal) this.loginModal.openModal();
    }, 100);
  }

  mapFormValuesToPostRequest() {
    this.postRequest.otherMobileNo = this.propertyPostForm.get('otherMobileNo')?.value || '';
    this.postRequest.propertyMeasure = this.propertyPostForm.get('propertyMeasure')?.value || '';
    this.postRequest.requestBudget = this.propertyPostForm.get('requestBudget')?.value || '';
    this.postRequest.bedRooms = this.propertyPostForm.get('bedRooms')?.value || '';
    this.postRequest.bathRooms = this.propertyPostForm.get('bathRooms')?.value || '';
    this.postRequest.noLift = this.propertyPostForm.get('noLift')?.value || '';
    this.postRequest.propertyAge = this.propertyPostForm.get('propertyAge')?.value || '';
    this.postRequest.roadSize = this.propertyPostForm.get('roadSize')?.value || '';
  }

  SendConfirmationSMS(code: string) {
    const propType = this.postRequest.requestType == 1 ? 'Buy' : this.postRequest.requestType == 2 ? 'Rent' : 'Sale';
    const Text = `Congratulations! Your property ID ${code} for ${propType} is successfully posted on Buyrentsale.com - INEXT IT`;
    const userMobile = this.userProfileInfo?.MobileNo || this.authData?.MobileNo || this.userProfileInfo?.Phone;

    if (userMobile && /^[6-9]\d{9}$/.test(userMobile)) {
      this.postCommonService.SendSMS(Text, userMobile).subscribe();
    }
  }

  SendOtherConfirmationSMS(code: string) {
    const propType = this.postRequest.requestType == 1 ? 'Buy' : this.postRequest.requestType == 2 ? 'Rent' : 'Sale';
    const Text = `Congratulations! ${this.userProfileInfo.UserName} has posted a Property Request for ${propType} on behalf of you on BuyRentSale.com. Login to view the listing - AINEXT IT`;
    if (this.postRequest.otherMobileNo) {
      this.postCommonService.SendSMS(Text, this.postRequest.otherMobileNo).subscribe();
    }
  }

  loadMapBasedOnAddress() {
    if (!this.geocoder && typeof google !== 'undefined') {
      this.geocoder = new google.maps.Geocoder();
    }
    if (this.postRequest.address && this.postRequest.address.trim() !== '') {
      this.geocodeAddress(this.postRequest.address);
    }
  }

  geocodeAddress(address: string) {
    this.geocoder.geocode({ 'address': address }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results && results[0]) {
        const location = results[0].geometry.location;
        this.postRequest.lattitude = location.lat();
        this.postRequest.logitude = location.lng();
        this.initMap();
        this.showMap = true;
      }
    });
  }

  initMap() {
    const mapOptions = {
      center: { lat: this.postRequest.lattitude, lng: this.postRequest.logitude },
      zoom: 15
    };

    if (!this.map) {
      this.map = new google.maps.Map(document.getElementById('map'), mapOptions);
      this.marker = new google.maps.Marker({
        position: { lat: this.postRequest.lattitude, lng: this.postRequest.logitude },
        map: this.map,
        draggable: true
      });
      this.marker.addListener('dragend', (event: any) => {
        this.updateAddress(event.latLng.lat(), event.latLng.lng());
      });
    } else {
      this.map.setCenter({ lat: this.postRequest.lattitude, lng: this.postRequest.logitude });
      this.marker.setPosition({ lat: this.postRequest.lattitude, lng: this.postRequest.logitude });
    }
  }

  updateAddress(lat: number, lng: number) {
    const latlng = { lat, lng };
    this.geocoder.geocode({ 'location': latlng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results && results[0]) {
        this.postRequest.address = results[0].formatted_address;
        this.postRequest.lattitude = lat;
        this.postRequest.logitude = lng;
        this.GetAddress(this.postRequest.address);
      }
    });
  }

  GetAddress(address: string) {
    this.gpsLoaction = `https://www.google.com/maps/embed?origin=mfe&pb=!1m3!2m1!1s${this.postRequest.lattitude},${this.postRequest.logitude}!6i14!3m1!1sen!5m1!1sen&zoom=15`;
  }

  doChangeLocation(locationType: number) {
    document.getElementById('txtDescription')?.removeAttribute('readonly');
    this.isOtherLocation = locationType === 0;

    if (this.isOtherLocation) {
      this.postRequest.address = '';
      this.showMap = false;
      if (this.map) {
        this.marker.setMap(null);
        this.marker = null;
        const mapDiv = document.getElementById('map');
        if (mapDiv) mapDiv.innerHTML = '';
        this.map = null;
      }
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.postRequest.lattitude = position.coords.latitude;
        this.postRequest.logitude = position.coords.longitude;
        this.updateAddress(this.postRequest.lattitude, this.postRequest.logitude);
        this.initMap();
        this.showMap = true;
      });
    }
  }

  doUploadImage() {
    if (this.imgIndex <= 15 || this.videoIndex <= 1) {
      document.getElementById('propertyFiles')?.click();
    }
  }

  doUploadPanoromaImage() {
    if (this.panoramaIndex <= 3) {
      document.getElementById('propertyPanaromaFiles')?.click();
    }
  }

  PropertyFiles_change(event: any): void {
    const file = event.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop()?.toLowerCase();

    if (['gif', 'png', 'jpg', 'jpeg'].includes(ext || '')) {
      if (file.size > 3145728) {
        this.postCommonService.CallToster('E', 'Image size exceeds 3 MB. Please upload a smaller image.');
        return;
      }
      this.uploadImage(file);
    } else if (ext === 'mp4') {
      this.uploadVideo(file);
    } else {
      this.postCommonService.CallToster('E', 'Invalid file format. Please upload an image or an MP4 video only.');
    }
  }

  uploadImage(imageToUpload: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 1024;
        canvas.height = 768;
        ctx?.drawImage(img, 0, 0, 1024, 768);
        canvas.toBlob((blob) => {
          if (!blob) return;
          const formData = new FormData();
          formData.append('Image', blob, imageToUpload.name);
          this.isLoader = true;
          this.postUsersService.UploadImage(formData, 'PropertyPic').subscribe({
            next: (res) => {
              this.isLoader = false;
              if (!res.isError && res.status === 1) {
                this.imgIndex++;
                this.imageUpload.push({ imgPath: res.body, isVideo: false });
                this.cdr.detectChanges();
              } else {
                this.postCommonService.CallToster('E', 'Unable to upload image. Please try again later.');
              }
            },
            error: () => {
              this.isLoader = false;
              this.postCommonService.CallToster('E', 'Unable to upload image. Please try again later.');
            }
          });
        }, 'image/jpeg', 0.8);
      };
    };
    reader.readAsDataURL(imageToUpload);
  }

  async uploadVideo(videoToUpload: File): Promise<void> {
    const maxSizeInBytes = 20 * 1024 * 1024;
    if (videoToUpload.size > maxSizeInBytes) {
      this.postCommonService.CallToster('E', 'The file size exceeds the 20 MB limit. Please select a smaller file.');
      return;
    }

    const thumbnailBlob = await this.generateThumbnail(videoToUpload);
    const thumbnailFile = new File([thumbnailBlob], 'thumbnail.png', { type: 'image/png' });
    const formData = new FormData();
    formData.append('video', videoToUpload, videoToUpload.name);
    formData.append('thumbnail', thumbnailFile, thumbnailFile.name);

    this.isLoader = true;
    this.postUsersService.UploadImage(formData, 'PropertyVideo').subscribe({
      next: (res) => {
        this.isLoader = false;
        if (!res.isError && res.status === 1) {
          this.videoIndex++;
          this.imageUpload.push({ imgPath: res.body, isVideo: true });
          this.cdr.detectChanges();
        } else {
          this.postCommonService.CallToster('E', 'Unable to upload video. Please try again later.');
        }
      },
      error: () => {
        this.isLoader = false;
        this.postCommonService.CallToster('E', 'Unable to upload video. Please try again later.');
      }
    });
  }

  PropertyPanaromaFiles_change(event: any): void {
    const file = event.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop()?.toLowerCase();

    if (['gif', 'png', 'jpg', 'jpeg'].includes(ext || '')) {
      if (file.size > 3145728) {
        this.postCommonService.CallToster('E', 'Image size exceeds 3 MB. Please upload a smaller image.');
        return;
      }
      this.uploadPanoramaImage(file);
    } else {
      this.postCommonService.CallToster('E', 'Invalid file format. Please upload an image only.');
    }
  }

  uploadPanoramaImage(imageToUpload: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 1024;
        canvas.height = 768;
        ctx?.drawImage(img, 0, 0, 1024, 768);
        canvas.toBlob((blob) => {
          if (!blob) return;
          const formData = new FormData();
          formData.append('Image', blob, imageToUpload.name);
          this.isLoader = true;
          this.postUsersService.UploadImage(formData, 'PropertyPic').subscribe({
            next: (res) => {
              this.isLoader = false;
              if (!res.isError && res.status === 1) {
                this.panoramaIndex++;
                this.imagePanoromaUpload.push({ imgPath: res.body });
                this.cdr.detectChanges();
              } else {
                this.postCommonService.CallToster('E', 'Unable to upload image. Please try again later.');
              }
            },
            error: () => {
              this.isLoader = false;
              this.postCommonService.CallToster('E', 'Unable to upload image. Please try again later.');
            }
          });
        }, 'image/jpeg', 0.8);
      };
    };
    reader.readAsDataURL(imageToUpload);
  }

  generateThumbnail(videoFile: File): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.src = URL.createObjectURL(videoFile);
      video.onloadedmetadata = () => {
        const seekTo = video.duration > 1 ? 1 : 0;
        video.currentTime = seekTo;
      };
      video.onseeked = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('Failed to create thumbnail blob.')), 'image/png');
      };
      video.onerror = () => reject(new Error('Error loading video for thumbnail generation.'));
    });
  }

  selectRadio(radioButtonId: string) {
    const radioButton = document.getElementById(radioButtonId) as HTMLInputElement;
    if (radioButton) radioButton.click();
  }

  doSearch(eve: any) {
    const searchTerm = eve.target.value.toLowerCase();
    this.arrList = this.areasList.filter(area => area.AreaName.toLowerCase().includes(searchTerm));
  }

  // Dropdown toggle methods with auto-focus
  toggleBuyAreaDropdown(event: Event) {
    event.stopPropagation();
    if (!Array.isArray(this.postRequest.selectedAreasID)) {
      this.postRequest.selectedAreasID = this.postRequest.selectedAreasID ? [this.postRequest.selectedAreasID] : [];
    }
    this.showRentAreaDropdown = false;
    this.showBuyAreaDropdown = !this.showBuyAreaDropdown;
    if (this.showBuyAreaDropdown) this.focusSearchInput('.buy-area-dropdown .buy-area-search');
  }

  toggleRentAreaDropdown(event: Event) {
    event.stopPropagation();
    this.showBuyAreaDropdown = false;
    this.showRentAreaDropdown = !this.showRentAreaDropdown;
    if (this.showRentAreaDropdown) this.focusSearchInput('.rent-area-dropdown .rent-area-search');
  }

  toggleAmenityDropdown(event: Event) {
    event.stopPropagation();
    this.showAmenityDropdown = !this.showAmenityDropdown;
    if (this.showAmenityDropdown) this.focusSearchInput('.amenity-dropdown .amenity-search');
  }

  private focusSearchInput(selector: string): void {
    setTimeout(() => {
      const searchInput = document.querySelector(selector) as HTMLInputElement;
      searchInput?.focus();
    }, 100);
  }

  @HostListener('document:click')
  closeAllDropdowns() {
    this.showBuyAreaDropdown = false;
    this.showRentAreaDropdown = false;
    this.showAmenityDropdown = false;
  }

  // Area search methods
  onBuyAreaSearchInput(): void {
    this.cdr.detectChanges();
  }

  clearBuyAreaSearch(): void {
    this.buyAreaSearchTerm = '';
    this.cdr.detectChanges();
  }

  removeSelectedBuyArea(areaId: any): void {
    const selectedIds = Array.isArray(this.postRequest.selectedAreasID) ? [...this.postRequest.selectedAreasID] : [];
    const index = selectedIds.findIndex((id: any) => String(id) === String(areaId));
    if (index > -1) {
      selectedIds.splice(index, 1);
      this.postRequest.selectedAreasID = selectedIds;
      this.cdr.detectChanges();
    }
  }

  onRentAreaSearchInput(): void {
    this.cdr.detectChanges();
  }

  clearRentAreaSearch(): void {
    this.rentAreaSearchTerm = '';
    this.cdr.detectChanges();
  }

  clearSelectedRentArea(): void {
    this.postRequest.selectedAreasID = '';
    this.cdr.detectChanges();
  }

  getAreaNameById(areaId: any): string {
    if (!areaId) return '';
    const area = this.areasList.find(a => String(a.AreaID) === String(areaId));
    return area ? area.AreaName : '';
  }

  getFilteredBuyAreas(): any[] {
    const term = (this.buyAreaSearchTerm || '').trim().toLowerCase();
    if (!term) return this.areasList || [];
    return (this.areasList || []).filter(area => (area.AreaName || '').toLowerCase().includes(term));
  }

  getFilteredRentAreas(): any[] {
    const term = (this.rentAreaSearchTerm || '').trim().toLowerCase();
    if (!term) return this.areasList || [];
    return (this.areasList || []).filter(area => (area.AreaName || '').toLowerCase().includes(term));
  }

  isBuyAreaSelected(areaId: any): boolean {
    const selectedIds = Array.isArray(this.postRequest.selectedAreasID) ? this.postRequest.selectedAreasID : [];
    return selectedIds.some((id: any) => String(id) === String(areaId));
  }

  isRentAreaSelected(areaId: any): boolean {
    return String(this.postRequest.selectedAreasID) === String(areaId);
  }

  getSelectedBuyAreaText(): string {
    const selectedIds = Array.isArray(this.postRequest.selectedAreasID)
      ? this.postRequest.selectedAreasID
      : (this.postRequest.selectedAreasID ? [this.postRequest.selectedAreasID] : []);

    if (!selectedIds.length) return 'Select Areas';
    if (selectedIds.length === 1) return this.getAreaNameById(selectedIds[0]) || 'Select Areas';
    return `${selectedIds.length} areas selected`;
  }

  getSelectedRentAreaText(): string {
    if (!this.postRequest.selectedAreasID) return 'Select Area';
    return this.getAreaNameById(this.postRequest.selectedAreasID) || 'Select Area';
  }

  onBuyAreaToggle(areaId: any, event: Event) {
    const checkbox = event.target as HTMLInputElement;
    let selectedIds = Array.isArray(this.postRequest.selectedAreasID) ? [...this.postRequest.selectedAreasID] : [];
    const index = selectedIds.findIndex((id: any) => String(id) === String(areaId));

    if (checkbox.checked && index === -1) selectedIds.push(areaId);
    else if (!checkbox.checked && index > -1) selectedIds.splice(index, 1);

    this.postRequest.selectedAreasID = selectedIds;
    this.cdr.detectChanges();
  }

  onRentAreaSelect(areaId: any) {
    this.postRequest.selectedAreasID = areaId;
    this.rentAreaSearchTerm = '';
    this.showRentAreaDropdown = false;
    this.cdr.detectChanges();
  }

  // Amenities methods
  onAmenitySearchInput(): void {
    this.cdr.detectChanges();
  }

  clearAmenitySearch(): void {
    this.amenitySearchTerm = '';
    this.cdr.detectChanges();
  }

  removeSelectedAmenity(amenityId: any): void {
    const selected = Array.isArray(this.postRequest.Amenities) ? [...this.postRequest.Amenities] : [];
    const index = selected.findIndex((id: any) => String(id) === String(amenityId));
    if (index > -1) {
      selected.splice(index, 1);
      this.postRequest.Amenities = selected;
      this.cdr.detectChanges();
    }
  }

  getFilteredAmenities(): any[] {
    const term = (this.amenitySearchTerm || '').trim().toLowerCase();
    if (!term) return this.amenitiesList || [];
    return (this.amenitiesList || []).filter(a => (a.AmenityName || '').toLowerCase().includes(term));
  }

  getSelectedAmenityText(): string {
    const selected = Array.isArray(this.postRequest.Amenities) ? this.postRequest.Amenities : [];
    if (!selected.length) return 'Select Amenities';
    if (selected.length === 1) return this.getAmenityNameById(selected[0]) || 'Select Amenities';
    return `${selected.length} amenities selected`;
  }

  getAmenityNameById(amenityId: any): string {
    if (!amenityId) return '';
    const amenity = this.amenitiesList.find(a => String(a.AmenityID) === String(amenityId));
    return amenity ? amenity.AmenityName : '';
  }

  onAmenityToggle(amenityId: any, event: Event) {
    const checkbox = event.target as HTMLInputElement;
    let selected = Array.isArray(this.postRequest.Amenities) ? [...this.postRequest.Amenities] : [];
    const index = selected.findIndex((id: any) => String(id) === String(amenityId));

    if (checkbox.checked && index === -1) selected.push(amenityId);
    else if (!checkbox.checked && index > -1) selected.splice(index, 1);

    this.postRequest.Amenities = selected;
    this.cdr.detectChanges();
  }

  isAmenitySelected(amenityId: any): boolean {
    const selected = Array.isArray(this.postRequest.Amenities) ? this.postRequest.Amenities : [];
    return selected.some((id: any) => String(id) === String(amenityId));
  }

  doChangeRequestType(reqType: number) {
    this.isLoader = true;
    this.cdr.detectChanges();

    setTimeout(() => {
      this.zone.run(() => {
        this.postRequest.requestType = reqType;
        this.postRequest.requestBudget = '';
        this.postRequest.Amenities = [];
        this.postRequest.selectedAreasID = reqType === 1 ? [] : '';
        this.initSelectPickers();

        setTimeout(() => {
          this.zone.run(() => this.isLoader = false);
        }, 300);
      });
    }, 0);
  }

  ngAfterViewInit() {
    this.initSelectPickers();
    this.scheduleSelectPickerInitRetries();

    $(document).on('keypress', '.bootstrap-select .bs-searchbox input', function (e) {
      if (e.which === 13) {
        e.preventDefault();
        const $input = $(this);
        const $dropdown = $input.closest('.bootstrap-select');
        const $highlighted = $dropdown.find('.dropdown-menu li.active a');
        if ($highlighted.length) {
          $highlighted.click();
          $input.val('');
          $dropdown.find('.dropdown-menu li').removeClass('hidden');
        }
      }
    });
  }

  ngOnDestroy() {
    this.selectPickerTimerIds.forEach(timerId => clearTimeout(timerId));
    this.selectPickerTimerIds = [];
    $(document).off('keypress', '.bootstrap-select .bs-searchbox input');
  }

  private initSelectPickers() {
    setTimeout(() => {
      this.zone.runOutsideAngular(() => {
        const selectors = ['#txtAmenities'];
        selectors.forEach(selector => {
          const ele = $(selector);
          if (!ele.length) return;
          try { ele.selectpicker('destroy'); } catch (e) { }
          ele.selectpicker({ container: 'body' });
          ele.selectpicker('refresh');
        });
      });
    }, 0);
  }

  private scheduleSelectPickerInitRetries() {
    [300, 1000, 2500].forEach(delayMs => {
      const timerId = setTimeout(() => this.initSelectPickers(), delayMs);
      this.selectPickerTimerIds.push(timerId);
    });
  }

  validateInputs(): boolean {
    const zeroRegex = /^0$/;
    const fields = [
      { value: this.postRequest.bedRooms, name: 'Bed Rooms' },
      { value: this.postRequest.bathRooms, name: 'Bath Rooms' },
      { value: this.postRequest.requestBudget, name: 'Budget' },
      { value: this.postRequest.propertyMeasure, name: 'Measure' }
    ];

    for (const field of fields) {
      if (zeroRegex.test(field.value)) {
        this.postCommonService.CallToster('E', `${field.name} value cannot be zero.`);
        return false;
      }
    }
    return true;
  }

  showHelp = { noLift: false, propertyAge: false };
  toggleHelp(field: string): void { this.showHelp[field] = !this.showHelp[field]; }

  mobileNumberValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    return /^[0-9]{10}$/.test(control.value) ? null : { invalidMobileNumber: true };
  }

  selectParkingRadio(id: string): void {
    const radioBtn = document.getElementById(id) as HTMLInputElement;
    if (radioBtn) radioBtn.click();
  }

  allowDrop(event: DragEvent): void { event.preventDefault(); }

  handleDrop(event: DragEvent, type: 'I' | 'P'): void {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files?.length) {
      const fileEvent = { target: { files } } as any;
      type === 'I' ? this.PropertyFiles_change(fileEvent) : this.PropertyPanaromaFiles_change(fileEvent);
    }
  }
}

class PropertyPostEntity {
  RequestId: any = 0;
  UserID: number = 0;
  requestType: number = 0;
  propertyType: number = 0;
  selectedSubProdID: number = 0;
  requestForType: string = '';
  otherMobileNo: string = '';
  selectedAreasID: any[] = [];
  requestBudget: string = '';
  propertyMeasure: string = '';
  unitID: string = '';
  shortDescription: string = '';
  lattitude: string = '';
  logitude: string = '';
  address: string = '';
  status: number = 0;
  isPlot: boolean = false;
  isLand: boolean = false;
  bedRooms: string = '';
  bathRooms: string = '';
  noLift: string = '';
  propertyAge: string = '';
  isParking: string = "0";
  isElectricity: string = '0';
  isFencing: string = '0';
  roadType: string = '';
  roadSize: string = '';
  propertyFacing: string = '';
  layoutAuthority: string = '';
  socilType: string = '';
  cropPlantation: string = '';
  isWaterFacility: string = '0';
  distanceNHW: string = '';
  distanceORR: string = '';
  isTotal: boolean = false;
  ventureId: string = '';
  isVenture: boolean = false;
  reqStatus: number = 0;
  Amenities: any[] = [];
}

interface IImageUpload {
  imgPath: string;
  isVideo?: boolean;
}